import { SingleItemResponse } from 'types/generic.types';
import { Profile, ProfileCard } from 'types/profile';
import { Link } from './api.types';
import { Time } from './general.types';

export type InviteCollaboratorResponse = SingleItemResponse<
  Collaborator,
  'collaborator'
>;

export enum CollaboratorStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
}

export interface Collaborator {
  isSelf: boolean;
  permission: CollaboratorPermission;
  profile: Profile;
  profileCard?: ProfileCard;
  inviteeEmail?: string;
  status: CollaboratorStatus;
  userGuid?: string;
  created: Time;
  inviteGuid?: string;
  invitedBy?: {
    userGuid: string;
    profileCard: ProfileCard;
  };
  _links?: {
    deleteCollaborator?: Link;
    resendInvite?: Link;
  };
}

export type InviteType = 'Search' | 'Suggestions' | 'Email';

export interface InviteeUserGuidWithType {
  guid: string;
  inviteType: InviteType;
}

export interface InviteCollaboratorsPayload {
  inviteeUserGuids?: InviteeUserGuidWithType[];
  inviteeEmails?: string[];
  message?: string;
  permission: CollaboratorPermission;
}

export enum CollaboratorPermission {
  ADMIN = 'ADMIN',
  ROOT = 'ROOT',
}
